import { render, staticRenderFns } from "./BucketsList.vue?vue&type=template&id=15c9a0e8&scoped=true&"
import script from "./BucketsList.vue?vue&type=script&lang=js&"
export * from "./BucketsList.vue?vue&type=script&lang=js&"
import style0 from "./BucketsList.scss?vue&type=style&index=0&id=15c9a0e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c9a0e8",
  null
  
)

export default component.exports